/*=========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  progress: 100,
  practice: 100,
  relevancy: 100,
  skip: true
}
